import { icons } from "@patient-watch/icons";
import { commonComponents as e } from "@/components/common";
import FooterButtons from "@/components/common/FooterButtons";
import usePatientsQuery from "@/features/profile/api/usePatientsQuery";
import { fuzzySearch } from "@/services/fuzzySearch";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";

// import { PartialPatientT } from "@/@types/SupabaseTypes";
type State = {
    selectedPatient: any;
};

type Action = {
    updateSelectedPatient: (selectedPatient: State["selectedPatient"]) => void;
};

// Create your store, which includes both state and (optionally) actions
export const useSelectedPatientStore = create<State & Action>()(
    devtools(
        persist(
            (set) => ({
                selectedPatient: {},
                updateSelectedPatient: (selectedPatient) => set(() => ({ selectedPatient: selectedPatient })),
            }),
            {
                name: "selected-patient",
            }
        )
    )
);

interface Props {
    nextStage: () => void;
}

const SelectPatient = ({ nextStage }: Props) => {
    const [searchFocused, _setSearchFocused] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const searchRef = useRef<any>(null);

    const [, updateSelectedPatient] = useSelectedPatientStore(
        (state) => [state.selectedPatient, state.updateSelectedPatient],
        shallow
    );

    const { data: patients, isLoading } = usePatientsQuery();

    const filteredPatients = fuzzySearch(patients, searchInput, "name");

    useEffect(() => {
        if (searchFocused) {
            searchRef.current?.focus();
        }
    }, [searchFocused]);

    const handlePatientSelect = (patient: any) => {
        updateSelectedPatient(patient);
        nextStage();
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <e.Title words="Select Patient" />
            <div className="space-y-4">
                <div className="relative">
                    <input
                        ref={searchRef}
                        type="text"
                        placeholder="Search patients..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        className="p-2 border rounded-md w-full"
                    />
                </div>
                <div className="space-y-2">
                    {filteredPatients?.map((patient) => (
                        <div
                            key={patient.id}
                            onClick={() => handlePatientSelect(patient)}
                            className="hover:bg-gray-50 p-3 border rounded-md cursor-pointer"
                        >
                            <div className="font-medium">{patient.name}</div>
                            <div className="text-gray-500 text-sm">{patient.email}</div>
                        </div>
                    ))}
                </div>
            </div>
            <FooterButtons
                func1={() => nextStage()}
                words1="Next"
                icon1={
                    <div className="flex justify-center items-center ml-[2px] p-[6px] w-8 h-8 rotate-180">
                        <icons.BackArrow fill="white" />
                    </div>
                }
            />
        </>
    );
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/new/select-patient")({
    component: SelectPatient,
});
